import "./styles.scss";

import { useTranslation } from "react-i18next";

import ModalNew from "components/ModalNew";
import SelectablePill from "components/SelectablePill";

import task_priority_data from "libs/task_priority_data.json";

const mainClass = "priority-explanation";

const PriorityExplanation = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  return (
    <ModalNew
      title={t("Available priorities and their meanings")}
      description={t("How priorities work?")}
      variant="wide"
      isOpen={isOpen}
      isSubmitHidden
      onClose={onClose}
    >
      <div className={mainClass}>
        <div className={`${mainClass}__header`}>
          <h6>{t("Explanation")}</h6>
        </div>
        <div className={`${mainClass}__list`}>
          {task_priority_data?.map(({ value, label, color, description }) => (
            <div key={value} className={`${mainClass}__list__item`}>
              <div className={`${mainClass}__list__item-pill`}>
                <SelectablePill
                  data={{
                    value: value,
                    label: t(label),
                    color: color,
                  }}
                  icon="flag"
                />
              </div>
              <div className={`${mainClass}__list__item-description`}>
                <p>{t(description)}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </ModalNew>
  );
};

export default PriorityExplanation;
